<div class="instructions" [ngClass]="{'visible': show}">
  <div class="instructions-wrap">
    <h1>Photo Guide</h1>
    <ul>
      <li class="guide-item" *ngFor="let item of items">
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.5003 21.0837C16.7931 21.0837 21.0837 16.7931 21.0837 11.5003C21.0837 6.2076 16.7931 1.91699 11.5003 1.91699C6.2076 1.91699 1.91699 6.2076 1.91699 11.5003C1.91699 16.7931 6.2076 21.0837 11.5003 21.0837Z" stroke="currentColor" stroke-width="2"/>
          <path d="M8.14648 11.9795L10.0632 13.8962L14.8548 9.10449" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ item }}</span>
      </li>
    </ul>

    <div class="image-wrap">
      <img src="assets/img/capt-correct.png" alt="Correct image example">
    </div>

    <button mat-flat-button
            class="btn btn--l btn--primary full-width"
            (click)="onConfirm(true)">Understood</button>

  </div>
</div>
